import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import * as Entities from '../../entities/index';
import { ConfigurationService } from '../config/config.service';
import { ListResponse } from 'app/_shared/models/list-response.model';
import { Result } from 'app/_shared/models/api.model';
import { SearchRetailerPhoneNumbersRequest } from '../../entities/entities';

@Injectable({
  providedIn: 'root',
})
export class RetailerPhoneNumbersService {
  serviceUri: string;
  RetailerPhoneNumbers: BehaviorSubject<Entities.RetailerPhoneNumber[]> = new BehaviorSubject<Entities.RetailerPhoneNumber[]>([]);

  constructor(
    private http: HttpClient,
    private config: ConfigurationService) {
    this.config.Config.subscribe((config) => {
      this.serviceUri = `${config.apiUri}/retailers/`;
    });
  }

  async load(force: boolean, retailerId: number): Promise<void> {
    if (!force && this.RetailerPhoneNumbers.value.length > 0) {
      console.debug('Retailers programs already loaded');
      return;
    }
    const result = await lastValueFrom(this.http.get<Result<ListResponse<Entities.RetailerPhoneNumber>>>(this.serviceUri + retailerId + '/phone-numbers/'));
    if (result.successful && result.data) {
      this.RetailerPhoneNumbers.next(result.data.records);
    }
  }

  search(request: SearchRetailerPhoneNumbersRequest) : Observable<Result<ListResponse<Entities.RetailerPhoneNumber>>> {
    return this.http.post<Result<ListResponse<Entities.RetailerPhoneNumber>>>(
      this.serviceUri + 'phone-numbers/search',
      request
    );
  }
}
